/**
 * Provider → logo asset mapping, shared by the Models listing, the model
 * drawers and the Agent Designer's Configure panel so the same iconography is
 * used everywhere (matches the byom-v2-option2 prototype's providerLogoImg()).
 */
import openaiLogo from '@assets/boomi-ai/ui-kit/agentFoundation/openai-logo.png';
import customCloud from '@assets/boomi-ai/ui-kit/agentFoundation/custom-cloud.svg';
import type { ModelProvider } from '@components/ModelsManagement/types/models.types';
import boomiFavicon from '@assets/boomi-ai/ui-kit/agentFoundation/boomi-logo.png';
import geminiLogo from '@assets/boomi-ai/ui-kit/agentFoundation/gemini-logo.png';
import claudeLogo from '@assets/boomi-ai/ui-kit/agentFoundation/claude-logo.png';
import jevLogo from '@assets/boomi-ai/ui-kit/agentFoundation/jev-logo.png';

export interface ProviderLogo {
  src: string;
  alt: string;
}

export default function providerLogo(
  provider: ModelProvider | string,
  boomi = false,
): ProviderLogo {
  if (boomi || provider === 'Boomi') return { src: boomiFavicon, alt: 'Boomi' };
  switch (provider) {
    case 'Anthropic':
    case 'anthropic':
      return { src: claudeLogo, alt: 'Anthropic' };
    case 'OpenAI':
    case 'openai':
      return { src: openaiLogo, alt: 'OpenAI' };
    case 'Gemini':
    case 'gemini':
    case 'Google':
    case 'google':
      return { src: geminiLogo, alt: 'Gemini' };
    case 'Typesafe':
    case 'typesafe':
      return { src: jevLogo, alt: 'Typesafe' };
    default:
      return { src: customCloud, alt: provider || 'Custom' };
  }
}
